export const Policy = () => {
  return (
    <div className="w-full bg-gray-1 py-2 text-policy text-gray-5">
      <div className="flex flex-col items-center justify-center">
        <p>
          해당 버튼을 통해 구매시 똑소에 수익이 발생합니다. 발생한 수익은
          서비스를 무료로 운영하기 위해 사용됩니다.
        </p>
        <p>
          똑소의 정보는 쿠팡의 정보와 일치하지 않을 수 있으므로 반드시 쿠팡에서
          정확한 정보를 확인하시기 바랍니다.
        </p>
      </div>
    </div>
  )
}
